import cn from 'classnames';
import { useContext } from 'react';
import { CartContext, MiniCartContext } from '../cart/CartContext';
import { cartURL } from '../config/SiteConfig';
import useOnMount from '../utils/useOnMount';
import * as style from './HeaderIconLink.module.css';
import MiniCartIcon from './MiniCartIcon';

export default function MiniCart({}: { active?: boolean }) {
    const cart = useContext(CartContext);
    const miniCart = useContext(MiniCartContext);

    useOnMount(() => {
        cart.fetchMiniCart(shouldForceReloadCart());

        document.addEventListener('visibilitychange', () => {
            if (document.visibilityState === 'visible') {
                cart.fetchMiniCart();
            }
        });
    });

    return (
        <a href={cartURL()} rel="nofollow" aria-label={`Handlekurv, ${miniCart?.totalUnitCount ?? 0} varer`} className={cn(style.link, style.cart)}>
            <MiniCartIcon itemCount={miniCart?.totalUnitCount} />
            <span>Handlekurv</span>
        </a>
    );
}

function shouldForceReloadCart() {
    if (location.pathname.startsWith('/cart')) return true;
    if (location.pathname.startsWith('/checkout')) return true;
    return false;
}
